<div class="expandable-text-wrapper">
  <div class="expandable-text-cta">
    <div class="editor-actions">
      <ng-content select="[editor-extra-actions]"></ng-content>
    </div>
    <div class="expandable-text-expand" (click)="toggleExpanded()">
      {{ isExpanded ? 'Collapse ↑' : 'Expand ↓' }}
    </div>
  </div>

  <dx-html-editor
    #htmlEditor
    class="html-editor"
    [ngClass]="{
      expanded: isExpanded,
      collapsed: !isExpanded,
      invalid: isInvalid
    }"
    [style.--collapsed-rows]="collapsedRows"
    [(value)]="value"
    (valueChange)="onValueChange($event)"
    [readOnly]="readOnly"
    [placeholder]="placeholder"
    (onContentReady)="onEditorContentReady($event)"
  >
    <dxo-toolbar *ngIf="!readOnly" [multiline]="true">

      <dxi-item name="undo"></dxi-item>
      <dxi-item name="redo"></dxi-item>

      <dxi-item name="separator"></dxi-item>
      <dxi-item name="size" [acceptedValues]="fontSizes" [options]="sizeItemOptions"></dxi-item>
      <dxi-item name="font" [acceptedValues]="fontFamilies" [options]="fontItemOptions"></dxi-item>

      <dxi-item name="separator"></dxi-item>

      <dxi-item name="bold"></dxi-item>
      <dxi-item name="italic"></dxi-item>
      <dxi-item name="strike"></dxi-item>
      <dxi-item name="underline"></dxi-item>

      <dxi-item name="separator"></dxi-item>
      <dxi-item name="alignLeft"></dxi-item>
      <dxi-item name="alignCenter"></dxi-item>
      <dxi-item name="alignRight"></dxi-item>
      <dxi-item name="alignJustify"></dxi-item>
      <dxi-item name="separator"></dxi-item>

      <dxi-item name="orderedList"></dxi-item>
      <dxi-item name="bulletList"></dxi-item>

      <dxi-item name="separator"></dxi-item>
      <dxi-item name="header" [acceptedValues]="headerLevels"></dxi-item>
      <dxi-item name="separator"></dxi-item>

      <dxi-item name="color"></dxi-item>
      <dxi-item name="background"></dxi-item>

      <dxi-item
        name="clear"
        widget="dxButton"
        [options]="clearButtonOptions"
      ></dxi-item>

      <dxi-item name="separator"></dxi-item>
      <dxi-item name="link"></dxi-item>
      <dxi-item name="separator"></dxi-item>

      <dxi-item
        name="lineheight"
        [acceptedValues]="lineHeights"
        [options]="{
          placeholder: ('COMMON.FIELDS.LINE-HEIGHT' | translate)
        }"
      ></dxi-item>

      <dxi-item name="separator"></dxi-item>

      <dxi-item name="insertTable"></dxi-item>
      <dxi-item name="deleteTable"></dxi-item>
      <dxi-item name="insertRowAbove"></dxi-item>
      <dxi-item name="insertRowBelow"></dxi-item>
      <dxi-item name="deleteRow"></dxi-item>
      <dxi-item name="insertColumnLeft"></dxi-item>
      <dxi-item name="insertColumnRight"></dxi-item>
      <dxi-item name="deleteColumn"></dxi-item>

    </dxo-toolbar>
  </dx-html-editor>

  <div class="validation-message" *ngIf="isInvalid">
    {{ 'VALIDATIONS.CONTENT-REQUIRED' | translate }}
  </div>
</div>